function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M18.89 5.11l-13.1 13.1c-1.89-2.57-3.25-5.85-2.41-9.52.52-2.31 1.8-3.98 3.38-5.08C8.34 2.52 10.23 2 12 2c2.44 0 5.12.98 6.89 3.11zm-3.11 15.87A5.436 5.436 0 0112 22.51c-1.36 0-2.72-.52-3.78-1.54-.36-.34-.72-.72-1.08-1.11l12.9-12.9c.25.54.44 1.11.58 1.74 1.17 5.16-1.99 9.52-4.84 12.28z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.77 2.23a.743.743 0 00-1.08 0L15.02 7.9l-.72.72A2.848 2.848 0 0012 7.44c-1.58 0-2.87 1.29-2.87 2.87 0 .9.44 1.75 1.18 2.3l-8.08 8.08c-.31.3-.31.78 0 1.08.15.15.34.23.54.23s.39-.08.54-.23L21.77 3.31c.31-.3.31-.78 0-1.08z"
})));